import { Observable } from 'rxjs'
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { OrgLevelGateway } from './organization-gateway'
import { OrgLevelModel } from '../models/orgLevelModel'
import { OrganizationModel } from '../models/OrganizationModel'
import { ValidatedSelectOptionModel } from '../../validations/validated-dropdown.component'
import { CagPlan } from '../models/cagplan'
import { AddPlanToOrgModel } from '../models/add-plan-to-org'
import { OrgListData } from '../models/org-list-data'
import { VwOrgLevelDetails } from '../models/view-orglevel-details'
import { GetOrgList } from '../models/get-org-list'
import { CagFilter } from '../models/cag-filter'

@Injectable()
export class NetworkOrganizationGateway extends OrgLevelGateway {
    constructor(private http: HttpClient) {
        super()
    }

    getOrgLevelDetails(parent: number): Observable<OrgLevelModel[]> {
        let getURL = '../api/getOrgLevel/' + parent
        return this.http.get<OrgLevelModel[]>(getURL)
    }

    getOrgListData(getOrgList: GetOrgList): Observable<OrgListData[]> {
        let getURL = '../api/getOrgListData'
        return this.http.post<OrgListData[]>(getURL, JSON.stringify(getOrgList))
    }

    getOrgListDataSync(getOrgList: GetOrgList): OrgListData[] {
        var data = JSON.stringify(getOrgList)
        var xhr = new XMLHttpRequest()
        xhr.open('POST', '../api/getOrgListData', false)
        xhr.setRequestHeader('content-type', 'application/json')
        xhr.send(data)
        if (xhr.readyState == 4 && xhr.status == 200) {
            return JSON.parse(xhr.responseText)
        }
        return JSON.parse(xhr.responseText)
    }

    getAllStates(): Observable<ValidatedSelectOptionModel[]> {
        let URL = '../api/GetStates'
        return this.http.get<ValidatedSelectOptionModel[]>(URL)
    }
    getNotAddedStates(orgId: number): Observable<ValidatedSelectOptionModel[]> {
        let URL = '../api/GetNotAddedStates/' + orgId
        return this.http.get<ValidatedSelectOptionModel[]>(URL)
    }

    getFMO(): Observable<ValidatedSelectOptionModel[]> {
        let URL = '../api/getParents'
        return this.http.get<ValidatedSelectOptionModel[]>(URL)
    }

    addFMO(FMODetails: OrganizationModel): Observable<number> {
        return this.http.post<number>('../api/addFMO', JSON.stringify(FMODetails))
    }

    //getCAGPlans(orgId: number, cuid: string): Observable<CagPlan[]> {
    //    let getCagPlanURL = '../api/GetCAGPlans/' + orgId + '/' + cuid
    //    return this.http.get<CagPlan[]>(getCagPlanURL)
    //}

    getCAGPlans(filterData: CagFilter): Observable<CagPlan[]> {
        let getCagPlanURL = '../api/GetCAGPlans/'
        return this.http.post<CagPlan[]>(getCagPlanURL, JSON.stringify(filterData))
    }

    getCAGPlansSync(filterData: CagFilter): CagPlan[] {
        var data = JSON.stringify(filterData)
        var xhr = new XMLHttpRequest()
        xhr.open('POST', '../api/GetCAGPlans/', false)
        xhr.setRequestHeader('content-type', 'application/json')
        xhr.send(data)
        if (xhr.readyState == 4 && xhr.status == 200) {
            return JSON.parse(xhr.responseText)
        }
        return JSON.parse(xhr.responseText)
    }

    addPlans(planModel: AddPlanToOrgModel[]): Observable<number> {
        let addCagPlanURL = '../api/AddCAGPlan'
        return this.http.post<number>(addCagPlanURL, JSON.stringify(planModel))
    }

    getOrgDetailsByOrgID(orgId: number): Observable<VwOrgLevelDetails> {
        return this.http.get<VwOrgLevelDetails>(`../api/GetOrgDetails/${orgId}`)
    }

    getOrgListByOrgName(orgName: string): Observable<OrgListData[]> {
        let headers = new HttpHeaders()
        headers = headers.set('Content-Type', 'application/json')
        let params = new HttpParams().set('orgName', orgName)
        let getURL = '../api/GetOrgListByOrgName/'
        return this.http.get<OrgListData[]>(getURL, { headers: headers, params: params })
    }

    getMarketingType(orgid: any): Observable<ValidatedSelectOptionModel[]> {
        //let URL = '../api/getMarketingType'
        //return this.http.get<ValidatedSelectOptionModel[]>(URL)
        return this.http.get<ValidatedSelectOptionModel[]>(`../api/getMarketingType/${orgid}`)
    }

    getInsuranceCoOrgID(coOrgID: number): Observable<number> {
        return this.http.get<number>(`../api/getInsuranceCoOrgID/${coOrgID}`)
    }
}
